import { Component, Input, OnInit } from '@angular/core';
import { Frac } from '~lmo/models/frac.model';

@Component({
  selector: 'sa-lmo-frac-home-hse-requirements',
  styleUrls: ['./lmo-frac-home-hse-requirements.component.scss'],
  templateUrl: './lmo-frac-home-hse-requirements.component.html',
})
export class LmoFracHomeHseRequirementsComponent implements OnInit {
  @Input() public frac: Frac;

  public get hseRequirements(): string {
    if (!this.frac || !this.frac.hseRequirements || this.frac.hseRequirements.trim() === '') {
      return 'None';
    }
    return this.frac.hseRequirements;
  }

  constructor() {}

  public ngOnInit() {}
}
